import { render } from "./alerta.vue?vue&type=template&id=7807ea48&scoped=true"
import script from "./alerta.vue?vue&type=script&lang=js"
export * from "./alerta.vue?vue&type=script&lang=js"

import "./alerta.vue?vue&type=style&index=0&id=7807ea48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7807ea48"]])

export default __exports__